module.exports = __webpack_public_path__ + "assets/img/frequency.3553aad9.svg";